<template>
    <div class="voucher-how-to hidden-print text-center" @click="openDialog">
        {{$t('ReservationSteps.header')}}

        <Modal v-if="showModal" @close="closeDialog" closeOnEscape dismissible>
            <GuideSteps :steps="steps" class="reservation-steps">
                <template v-slot:header>
                    {{$t('ReservationSteps.modal.header')}}
                </template>
                <template slot="default">
                    <EmbeddedVideo videoId="itB-5p4_MTo" class="hotel-voucher-video" v-if="$store.state.ident !== 'www.animod.nl' && $store.state.ident !== 'kurzinurlaub'"/>

                    <translate tag="div" path="ReservationSteps.additionalInfo" class="info-text mt-3">
                        <template v-slot:phone>
                            <a :href="'tel:' + supportPhoneNumber">
                                <strong>{{supportPhoneNumber}}</strong>
                            </a>
                        </template>
                        <template v-slot:email>
                            <a href="mailto:info@animod.de">
                                <strong>{{$t('Contact.email')}}</strong>
                            </a>
                        </template>
                    </translate>
                </template>
            </GuideSteps>
        </Modal>
    </div>
</template>

<script>
    import GuideSteps from '@/components/guideSteps/GuideSteps';
    import Modal from '@/components/Modal';
    import EmbeddedVideo from '@/components/EmbeddedVideo';
    import Step from '@/models/GuideStep';

    export default {
        name: 'ReservationSteps',
        components: {
            GuideSteps,
            Modal,
            EmbeddedVideo
        },
        data() {
            return {
                showModal: false,
                steps: [
                    new Step(
                        require('@/assets/guideSteps/1.png'),
                        this.$t('ReservationSteps.step1')
                    ),
                    new Step(
                        require('@/assets/guideSteps/2.png'),
                        this.$t('ReservationSteps.step2')
                    ),
                    new Step(
                        require('@/assets/guideSteps/3.png'),
                        this.$t('ReservationSteps.step3', {
                            serviceUrl: this.serviceUrl
                        })
                    )
                ]
            };
        },
        computed: {
            supportPhoneNumber() {
                return this.$store.state.globalMeta.supportPhoneNumber;
            },
            serviceUrl() {
                return this.$store.state.ident === 'kurzinurlaub'
                    ? '<a href="https://einloesen.kurz-in-urlaub.de" target="_blank">einloesen.kurz-in-urlaub.de</a>'
                    : '<a href="https://gutschein.animod.de" target="_blank">gutschein.animod.de</a>'
            }
        },
        methods: {
            openDialog() {
                this.showModal = true;
            },
            closeDialog() {
                this.showModal = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .reservation-steps {
        font-size: 18px;

        ::v-deep {
            h2.heading {
                padding-top: 5px;
                padding-bottom: 10px;
            }
        }
    }

    .hotel-voucher-video {
        margin: 10px auto;
    }

</style>
